import { Output,EventEmitter } from '@angular/core';
import { OnInit } from '@angular/core';
import { Component } from '@angular/core';
import { BasePopupComponent } from '../../../directives/base-popup.directive';
import { QuoteDetail } from '../../../models/QuoteDetail';


@Component({
  selector: 'app-edit-sp-line',
  standalone: false,  
  templateUrl: './edit-sp-line.component.html',
  styleUrl: './edit-sp-line.component.css'
})
export class EditSpLineComponent extends BasePopupComponent implements OnInit {
  //@Output() CloseEventEmitter: EventEmitter<any> = new EventEmitter();
  //@Output() ActionEventEmitter: EventEmitter<QuoteDetail> = new EventEmitter();
  public CurrentSPDetail: QuoteDetail;
  public constructor() {
    super();
    this.CurrentSPDetail = new QuoteDetail();
  }

  ngOnInit() {

  }


  AddSPLine() {
    if (this.CurrentSPDetail.RowPointer == "") {
      this.CurrentSPDetail.LineNote = "This part number is a temporary code for ordering purposes.  Order must be revised once a permanent 8-digit part number is assigned by Tolomatic.";
      
    }

    this.ActionEventEmitter.emit(this.CurrentSPDetail);
  }

  CloseWindow() {
    this.CloseEventEmitter.emit("");
  }
}
